import React,{useState,useEffect} from 'react'
import axios from 'axios'
import {useAuth} from '../index'
import {
  PaymentElement,
  Elements,
  CardElement,
  useCheckout,
  CheckoutProvider,
  StripeElements,
  useStripe,
  useElements
} from '@stripe/react-stripe-js'
import {
  loadStripe
} from '@stripe/stripe-js'
import { IoReturnDownBackSharp } from 'react-icons/io5'
import { FaCcMastercard } from 'react-icons/fa6'
import { FaCcVisa,FaCcAmex,FaCcPaypal,FaCcApplePay,FaAlipay } from 'react-icons/fa'
import { HiMiniCheck } from 'react-icons/hi2'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
const stripeTestPromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
const CARD_OPTIONS = {
	iconStyle: "solid",
	style: {
		base: {
			iconColor: "#c4f0ff",
			color: 'white',
			fontWeight: 500,
			fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
			fontSize: "24px",
			fontSmoothing: "antialiased",
			":-webkit-autofill": { color: "#fce883" },
			"::placeholder": { color: "#87bbfd" }
		},
		invalid: {
			iconColor:'red',
			color: 'red'
		}
	}
}
function Payment_Premium_1({userInfo2}){
  return (
    <Elements stripe={stripeTestPromise}>
      <Payment_Premium_2 userInfo3={userInfo2}/>
    </Elements>
  )
}
function Payment_Dev_Premium_1({userInfo2}){
  return (
    <Elements stripe={stripeTestPromise}>
      <Payment_Dev_Premium_2 userInfo3={userInfo2}/>
    </Elements>
  )
}
function Payment_Premium_2({userInfo3}){
  const [success,setSuccess]=useState(false)
  const [clientSecret,setClientSecret]=useState('')
  const [customerId,setCustomerId] = useState('')
  const [subscriptionId,setSubscriptionId] = useState('')
  const [receiptID,setReceiptID]=useState('')
  const [loading,setLoading]=useState(false)
  const stripe = useStripe()
  const element = useElements()
  useEffect(()=>{
    onClick2SecretKey()
  },[])
  const onClick2SecretKey = async()=>{
    const res=await axios.post(`${APIURL}/subscribe-payment-premium1`,{name:`${userInfo3.firstname} ${userInfo3.lastname}`,email:userInfo3.email})
    setClientSecret(res.data.client_secret)
    setCustomerId(res.data.customer_id)
    setSubscriptionId(res.data.sub_id)
  }
  const onClick2Payment=async(e)=>{
    e.preventDefault()
    setLoading(true)
    const {err,paymentIntent}=await stripe.confirmCardPayment(clientSecret,{
      payment_method:{
      card: element.getElement(CardElement),
      billing_details:{name:`${userInfo3.firstname} ${userInfo3.lastname}`,email:userInfo3.email}
    }})
    if(paymentIntent.status==='succeeded'){
      try{
        // Subscription active AND card saved
        const res=await axios.post(`${APIURL}/subscribe-payment-premium2`,{
          name: `${userInfo3.firstname} ${userInfo3.lastname}`,
          email:userInfo3.email,
          // amount:1.08,
          amount:215.42,
          id:paymentIntent.payment_method,
          receipt_id:`${Math.floor(Math.random() * 1000000000)}`,
          customer_id:customerId,
          sub_id:subscriptionId,
          status:'paid'
        })
        setReceiptID(res.data.receipt_id)
        if(res.data.success){
          setSuccess(true)
          setLoading(false)
        }
      }catch(err){
        console.log('err',err)
      }
    }
  }
  return (
    <>
    {!success?
    <div className='w-auto sm:w-[580px] m-[1em]'>
    <h3 className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>1. Order Summary</h3>
    <div className='w-auto sm:w-[580px]'>
    <div className='flex justify-between mt-[8px]'>
      <div>
      {/* <div className='text-[12px]'>Premium membership ($10.00/m)</div> */}
      {/* <div className='text-[12px]'>Premium membership ($1.00/m)</div> */}
      <div className='text-[12px]'>Premium membership ($199.00/m)</div>
      </div>
      {/* <div className='mt-auto text-[12px]'>10.00</div> */}
      <div className='mt-auto text-[12px]'>199.00</div>
    </div>
    <div className='flex justify-between text-[12px]'>
      <div className='text-[8px] mb-[4px] leading-[1.2]'>
      <div>Tax country: United States</div>
      <div>Sales tax 8.25%</div>
      </div>
      {/* <div style={{margin: 'auto 0 0'}} className='text-[10px]'>{(10*.0825).toFixed(2)}</div> */}
      <div style={{margin: 'auto 0 0'}} className='text-[10px]'>{(199*.0825).toFixed(2)}</div>
    </div>
    <hr/>
    <div className='flex justify-between text-[12px]'>
      <div>Total</div>
      {/* <div className='text-md'>US${(10*.0825+10).toFixed(2)}</div> */}
      <div className='text-md'>US${(199*(.0825+1)).toFixed(2)}</div>
    </div>
    </div>
    <br/>
    <h3 className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>2. Payment Infromation</h3>
    <form onSubmit={onClick2Payment} className='shadow-none'>
      <div className='w-[260px] flex justify-end'><div className='text-[#414345] text-[24px] flex w-fit'><FaCcMastercard className='mr-[1px]'/><FaCcVisa className='mr-[1px]'/><FaCcAmex className='mr-[1px]'/><FaCcPaypal/></div></div>
      <fieldset className='FormGroup w-[260px] mb-2'>
        <div className='text-[12px] FormRow border border-gray-800 pl-[2px] pt-[2px] pb-[2px]'>
        <CardElement option={CARD_OPTIONS}/>
        </div>
      </fieldset>
      <div className='mt-[2em] sm:ml-auto w-fit'><button className='bitter bg-[#414c75] hover:bg-[#365c88] w-[150px] h-[28px] text-white text-[12px]'>{loading?<div className='w-max m-auto'><div className='secondary-loader'></div></div>:'Complete Purchase'}</button>{loading?<div className='text-left text-[8px]'>It will take 4 or 5 seconds..</div>:''}</div>
     </form>
    </div>
    :<div className='flex-col flex'><div className='mt-[2em] mb-[1.2em] flex justify-center bitter'>Your payment is completed.</div>
      <div className='m-auto text-[12px]'>
      <div className='text-[9px] mt-[8px] mb-[8px]'>
      Receipt ID: {receiptID}
      </div>
      Your account member status has been changed as premium.<br/>Invoice will be sent to your email address shortly.</div></div>}
    </>
  )
}
function Payment_Dev_Premium_2({userInfo3}){
  const [success,setSuccess]=useState(false)
  const [clientSecret,setClientSecret]=useState('')
  const [customerId,setCustomerId] = useState('')
  const [subscriptionId,setSubscriptionId] = useState('')
  const [receiptID,setReceiptID]=useState('')
  const [loading,setLoading]=useState(false)
  const stripe = useStripe()
  const element = useElements()
  useEffect(()=>{
    onClick2SecretKey()
  },[])
  const onClick2SecretKey = async()=>{
    const res=await axios.post(`${APIURL}/subscribe-payment-dev-premium1`,{name:`${userInfo3.firstname} ${userInfo3.lastname}`,email:userInfo3.email})
    setClientSecret(res.data.client_secret)
    setCustomerId(res.data.customer_id)
    setSubscriptionId(res.data.sub_id)
  }
  const onClick2Payment=async(e)=>{
    e.preventDefault()
    setLoading(true)
    const {err,paymentIntent}=await stripe.confirmCardPayment(clientSecret,{
      payment_method:{
      card: element.getElement(CardElement),
      billing_details:{name: `${userInfo3.firstname} ${userInfo3.lastname}`,email:userInfo3.email}
    }})
    if(paymentIntent.status==='succeeded'){
      try{
        const res2 = await axios.post(`${APIURL}/subscribe-payment-dev-premium2`,{
          name: `${userInfo3.firstname} ${userInfo3.lastname}`,
          email:userInfo3.email,
          // amount:2.16,
          amount:431.92,
          id:paymentIntent.payment_method,
          receipt_id:`${Math.floor(Math.random() * 1000000000)}`,
          customer_id:customerId,
          sub_id:subscriptionId,
          status:'paid'
        })
        setReceiptID(res2.data.receipt_id)
        if(res2.data.success){
          setSuccess(true)
          setLoading(false)
        }
      }catch(err){
        console.log('err',err)
      }
    }
  }
  return (
    <>
    {!success?
    <div className='w-auto sm:w-[580px] m-[1em]'>
    <h3 className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>1. Order Summary</h3>
    <div className='w-auto sm:w-[580px]'>
    <div className='flex justify-between mt-[8px]'>
      <div>
      {/* <div className='text-[12px]'>Dev Premium membership ($47.00/m)</div> */}
      {/* <div className='text-[12px]'>Dev Premium membership ($1.00/m)</div> */}
      <div className='text-[12px]'>Dev Premium membership ($399.00/m)</div>
      </div>
      {/* <div className='mt-auto text-[12px]'>47.00</div> */}
      <div className='mt-auto text-[12px]'>399.00</div>
    </div>
    <div className='flex justify-between text-[12px]'>
      <div className='text-[8px] mb-[4px] leading-[1.2]'>
      <div>Tax country: United States</div>
      <div>Sales tax 8.25%</div>
      </div>
      {/* <div style={{margin: 'auto 0 0'}} className='text-[10px]'>{(47*.0825).toFixed(2)}</div> */}
      <div style={{margin: 'auto 0 0'}} className='text-[10px]'>{(399*.0825).toFixed(2)}</div>
    </div>
    <hr/>
    <div className='flex justify-between text-[12px]'>
      <div>Total</div>
      {/* <div className='text-md'>US${(47*.0825+47).toFixed(2)}</div> */}
      <div className='text-md'>US${(399*(.0825+1)).toFixed(2)}</div>
    </div>
    </div>
    <br/>
    <h3 className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>2. Payment Infromation</h3>
    <form onSubmit={onClick2Payment} className='shadow-none'>
      <div className='w-[260px] flex justify-end'><div className='text-[#414345] text-[24px] flex w-fit'><FaCcMastercard className='mr-[1px]'/><FaCcVisa className='mr-[1px]'/><FaCcAmex className='mr-[1px]'/><FaCcPaypal/></div></div>
      <fieldset className='FormGroup w-[260px] mb-2'>
        <div className='text-[12px] FormRow border border-gray-800 pl-[2px] pt-[2px] pb-[2px]'>
        <CardElement option={CARD_OPTIONS}/>
        </div>
      </fieldset>
      <div className='mt-[2em] sm:ml-auto w-fit'><button className='bitter bg-[#414c75] hover:bg-[#365c88] w-[150px] h-[28px] text-white text-[12px]'>{loading?<div className='w-max m-auto'><div className='secondary-loader'></div></div>:'Complete Purchase'}</button>{loading?<div className='text-left text-[8px]'>It will take 4 or 5 seconds..</div>:''}</div></form>
    </div>
      :
      <div className='flex-col flex'><div className='mt-[2em] text-[12px] sm:text-[24px  mb-[1.2em] flex justify-center bitter'>Your payment is completed.</div>
      <div className='m-auto text-[12px]'>
      <div className='text-[9px] mt-[8px] mb-[8px]'>
      Receipt ID: {receiptID}
      </div>
      Your account member status has been changed as dev premium.<br/>Invoice will be sent to your email address shortly.</div></div>}
    </>
  )
}
export default function AccountMembershipPage() {
    const {auth2FA2,user2,logout} = useAuth()
    //     const [edit, setEdit] = useState(false)
    const [userInfo1,setUserInfo1] = useState(null)
    const [selectedMembership,setSelectedMembership] = useState('')
    const [loading,setLoading]=useState(false)
    const [cancelSubscriptionMsg,setCancelSubscriptionMsg] = useState('')
    useEffect(() => {
        if(userInfo1==null){
            console.log('log')
          const handleSubmit = async (e) => {
            const { data: res } = await axios.post(`${APIURL}/account-info/bill`, {token:window.localStorage.getItem('token')})
            if(res.msg==='user info ok'){
              setUserInfo1(res.user)
              setSelectedMembership(res.user.membership)
            }
            else{
              setTimeout(() => {
                localStorage.removeItem('user')
                localStorage.removeItem('token')
                logout()
              }, 3000)
            }
          }
          setTimeout(handleSubmit, 1)
        }
    })
    const onClick2SelectMembership =(x)=>{
        setSelectedMembership(x)
    }
    const onClick2Cancel = async() =>{
      setLoading(true)
      const { data: res } = await axios.post(`${APIURL}/cancel-subscribe`, {
        email:userInfo1.email,
        sub_id:userInfo1.membership_details[0].sub_id,
        membership_details:userInfo1.membership_details,
        membership:userInfo1.membership
      })
      console.log(res)
      setLoading(false)
      setCancelSubscriptionMsg(res.msg)
    }
    return(
    <div className='text-left m-auto md:mt-8 w-full md:w-[580px] text-[8px]'>
    <h2 className='mb-4 text-lg structure__main__subttl'>Account Membership</h2>
    {userInfo1==null?<div className='w-max m-auto mt-8 mb-8'><div className='secondary-loader'></div></div>:<>
    <div className='hidden sm:grid m-auto grid-cols-3 sm:max-w-[424px]'>
      <div style={{border:selectedMembership=='free'?'2px solid #404C75':'1px solid black',paddingRight:selectedMembership=='free'?'7px':'8px'}} className='cursor-default relative mt-4 structure__subscribe__item' onClick={()=>onClick2SelectMembership('free')}>
      <h3 className='bitter mt-[8px]'>Free Account</h3>
      <div className='mt-[12px] mb-[4px] text-right'>Free</div>
      · Finance app access<br/>
      <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: <span className='font-bold'>Only 1 item is creatable at income and expense page.</span></div>
      <div className='absolute bottom-[14px]'>
      {userInfo1.membership=='free'?<button className='bitter' disabled>Current plan</button>:<button className='hover:bg-[#414c75] hover:text-white mt-[84px] bitter border-[.2px] border-gray-800' style={{background:(userInfo1.membership=='premium'||userInfo1.membership=='dev premium')&&selectedMembership=='free'?'#414c75':'',color:(userInfo1.membership=='premium'||userInfo1.membership=='dev premium')&&selectedMembership=='free'?'#fff':'',border:(userInfo1.membership=='premium'||userInfo1.membership=='dev premium')&&selectedMembership=='free'?'0px':''}} onClick={()=>onClick2SelectMembership('free')}>{selectedMembership=='free'?'Selected plan':'Select plan'}</button>}
      </div>
      </div>
      <div className={`cursor-default relative mt-4 structure__subscribe__item`} style={{border:selectedMembership=='premium'?'2px solid #404C75':'1px solid black'}} onClick={()=>onClick2SelectMembership('premium')}>
      <h3 className='bitter mt-[8px]'>Premium</h3>
       <div className='mt-[12px] text-right'>US$199.00/m + Tax</div>
      {/* <div className='text-right'>US$1.00/m + Tax</div> */}
      {/* <div className='bitter mb-[4px] text-[7px] text-[#1a36c6] font-bold text-right'>test running(Jun-Aug)</div> */}
      · Finance app access<br/>
      <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: all editable</div>
      <div className='absolute bottom-[14px]'>
      {userInfo1.membership=='premium'?<button className='bitter' disabled>Current plan</button>:<button className='hover:bg-[#414c75] hover:text-white mt-[84px] bitter border-[.2px] border-gray-800' onClick={()=>onClick2SelectMembership('premium')} style={{background:(userInfo1.membership=='free'||userInfo1.membership=='dev premium')&&selectedMembership=='premium'?'#414c75':'',color:(userInfo1.membership=='free'||userInfo1.membership=='dev premium')&&selectedMembership=='premium'?'#fff':'',border:(userInfo1.membership=='free'||userInfo1.membership=='dev premium')&&selectedMembership=='premium'?'0px':''}}>{selectedMembership=='premium'?'Selected plan':'Select plan'}</button>}
      </div>
      </div>
      <div className='cursor-default relative mt-4 structure__subscribe__item' style={{border:selectedMembership=='dev premium'?'2px solid #404C75':'1px solid black'}} onClick={()=>onClick2SelectMembership('dev premium')}>
      <h3 className='bitter mt-[8px]'>Dev Premium</h3> 
      <div className='mt-[12px] text-right'>US$399.00/m + Tax</div>
      {/* <div className='text-right'>US$2.00/m + Tax</div> */}
      {/* <div className='bitter mb-[4px] text-[7px] text-[#1a36c6] font-bold text-right'>test running(Jun-Aug)</div> */}
      · Finance app access<br/>
     <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: all editable</div>
      · API unlimit access<br/>
      · Code Samples<br/>
      <div className='absolute bottom-[14px]'>
      {userInfo1.membership=='dev premium'?<button className='mt-[10px] bitter' disabled>Current plan</button>:<button className='hover:bg-[#414c75] hover:text-white mt-[84px] bitter border-[.2px] border-gray-800' onClick={()=>setSelectedMembership('dev premium')} style={{background:(userInfo1.membership=='free'||userInfo1.membership=='premium')&&selectedMembership=='dev premium'?'#414c75':'',color:(userInfo1.membership=='free'||userInfo1.membership=='premium')&&selectedMembership =='dev premium'?'#fff':'',border:(userInfo1.membership=='free'||userInfo1.membership=='premium')&&selectedMembership=='dev premium'?'0px':''}}>{selectedMembership=='dev premium'?'Selected plan':'Select plan'}</button>}
      </div>
      </div>
    </div>
    <div className='m-auto ml-[1em] block sm:hidden'>
      <div 
      style={{border:selectedMembership=='free'?'2px solid #404C75':'1px solid black',paddingRight:selectedMembership=='free'?'7px':'8px'}} className='structure__subscribe__item2 hover:bg-gray-100 cursor-default text-[10px] m-[2px] pt-[1em] pb-[1em] pl-[8px] w-fit' onClick={()=>onClick2SelectMembership('free')}>
        <div className='flex mb-[8px]'>
          <div className='mr-[12px] w-[100px]'> 
            <h3 className='bitter'>Free Account</h3><div>Free</div>
          </div>
          <div className='w-[220px]'>
          · Finance app access<br/>
          <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: <span className='font-bold'>Only 1 item is creatable at income and expense page.</span></div>
          </div>
        </div>    
        <div className='m-auto w-fit'>
          {userInfo1.membership=='free'?<button className='bitter' disabled>Current plan</button>:<button className='hover:bg-[#414c75] hover:text-white mt-[84px] bitter border-[.2px] border-gray-800' style={{background:(userInfo1.membership=='premium'||userInfo1.membership=='dev premium')&&selectedMembership=='free'?'#414c75':'',color:(userInfo1.membership=='premium'||userInfo1.membership=='dev premium')&&selectedMembership=='free'?'#fff':'',border:(userInfo1.membership=='premium'||userInfo1.membership=='dev premium')&&selectedMembership=='free'?'0px':''}} onClick={()=>onClick2SelectMembership('free')}>{selectedMembership=='free'?'Selected plan':'Select plan'}</button>}
        </div>
      </div>
      <div style={{border:selectedMembership=='premium'?'2px solid #404C75':'1px solid black', backgroundColor:selectedMembership=='premium'?'#F3F4F6':'',paddingRight:selectedMembership=='premium'?'7px':'8px'}} className='structure__subscribe__item2 w-fit hover:bg-gray-100 cursor-default text-[10px] m-[2px] pt-[1em] pb-[1em] pl-[8px] ' onClick={()=>onClick2SelectMembership('premium')}>
        <div className='flex'>
          <div className='mr-[12px] w-[100px]'> 
            <h3 className='bitter'>Premium</h3><div className='line-through'>US$199.00/m+Tax</div>
            <div>US$199.00/m+Tax</div>
            {/* <div className='bitter mb-[4px] text-[7px] text-[#1a36c6] font-bold'>test running(Jun-Aug)</div> */}
          </div>
          <div className='w-[220px]'>
          · Finance app access<br/>
          <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: all editable</div>
          </div>
        </div>    
        <div className='m-auto w-fit'><button className='w-[120px] h-[23px] hover:bg-[#414c75] hover:text-white bitter border-[.2px] border-gray-800' style={{background:selectedMembership=='premium'?'#414c75':'',color:selectedMembership=='premium'?'#fff':'',border:selectedMembership=='premium'?'0px':''}} onClick={()=>onClick2SelectMembership('premium')}>{selectedMembership=='premium'?'Selected plan':'Select plan'}</button></div>
      </div>
      <div style={{border:selectedMembership=='dev premium'?'2px solid #404C75':'1px solid black', backgroundColor:selectedMembership=='dev premium'?'#F3F4F6':'',paddingRight:selectedMembership=='dev premium'?'7px':'8px'}} className='structure__subscribe__item2 hover:bg-gray-100 cursor-default text-[10px] m-[2px] pt-[1em] pb-[1em] pl-[8px] w-fit' onClick={()=>onClick2SelectMembership('dev premium')}>
        <div className='flex mb-[8px]'>
          <div className='mr-[12px] w-[100px]'> 
            <h3 className='bitter'>Dev Premium</h3><div className='line-through'>US$399.00/m+Tax</div>
            <div>US$2.00/m+Tax</div>
            <div className='bitter mb-[4px] text-[7px] text-[#1a36c6] font-bold'>test running(Jun-Aug)</div>
          </div>
          <div className='w-[220px]'>
          · Finance app access<br/>
          <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: all editable</div>
          · API unlimit access<br/>
          · Code samples
        </div>    
        </div>    
        <div className='m-auto w-fit'><button className='w-[120px] h-[23px] hover:bg-[#414c75] hover:text-white bitter border-[.2px] border-gray-800' style={{background:selectedMembership=='dev premium'?'#414c75':'',color:selectedMembership=='dev premium'?'#fff':'',border:selectedMembership=='dev premium'?'0px':''}} onClick={()=>onClick2SelectMembership('dev premium')}>{selectedMembership=='dev premium'?'Selected plan':'Select plan'}</button></div>
      </div>
    </div>
    {userInfo1.membership=='free'&&selectedMembership=='premium'?
    <><Payment_Premium_1 userInfo2={userInfo1}/></>:''}
    {userInfo1.membership=='free'&&selectedMembership=='dev premium'?<><Payment_Dev_Premium_1 userInfo2={userInfo1}/></>:''}
    {(userInfo1.membership=='premium'||userInfo1.membership=='dev premium')&&selectedMembership=='free'?<div className='w-auto sm:w-[580px] m-[1em]'><h3 className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>Cancel Subscription</h3>{cancelSubscriptionMsg==''? <div className='w-auto sm:w-[580px] m-[1em]'>
    <div className='flex justify-between mb-2 mt-[1.2em]'>
      <p className='mb-1 leading-[1.2] text-[12px]'>{selectedMembership} membership<br/><div className='text-[12px] text-gray-400'>Free/mo</div></p>
      <div style={{margin: 'auto 0 0'}} className='text-[12px]'>US$0.00</div>
    </div>
    <hr/>
    <div className='flex justify-between text-[12px]'>
      <div>Total</div>
      <div className='text-[12px]'>US$0.00</div>
    </div><br/>
    <div className='text-center m-auto'><button className='text-[12px] w-[230px] h-[28px] bitter text-white bg-[#414c75] hover:bg-[#365c88]' onClick={onClick2Cancel}>{loading?<div className='w-max m-auto'><div className='secondary-loader'></div></div>:'Complete Cancelation'}</button>
    </div></div>:<div className='bitter w-fit mt-[2em] text-[12px] sm:text-[24px]  m-auto'>{cancelSubscriptionMsg}</div>}
    </div>:''}
    <br/>
    </>}
    </div>
    )
}
